import styled from 'styled-components'

const Wrapper = styled.div`
	width: ${({width}) => width};
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 8px;
`

const Title = styled.div`
	font-size: 14px;
	font-weight: 600;
	color: #333;
`

const Container = styled.div`
	width: 100%;
	height: 40px;
	border: 1px solid #c2c2c2;
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 15px;
	background-color: #fff;
	cursor: pointer;
	user-select: none;
`

const SelectedValue = styled.div`
	font-size: 14px;
	color: #333;
`

const Arrow = styled.div`
	width: 0;
	height: 0;
	border-left: 5px solid transparent;
	border-right: 5px solid transparent;
	border-top: 5px solid #666;
	transform: ${({$isOpen}) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
	transition: transform 0.2s ease;
`

const DropdownList = styled.ul`
	position: absolute;
	top: calc(100% + 5px);
	left: 0;
	width: 100%;
	max-height: 200px;
	overflow-y: auto;
	background-color: #fff;
	border: 1px solid #c2c2c2;
	border-radius: 5px;
	z-index: 1000;
	padding: 5px 0;
	margin: 0;
	list-style: none;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`

const OptionItem = styled.li`
	padding: 10px 15px;
	font-size: 14px;
	color: ${({$isSelected}) => ($isSelected ? '#007bff' : '#333')};
	background-color: ${({$isSelected}) => ($isSelected ? '#f0f8ff' : '#fff')};
	cursor: pointer;
	transition: background-color 0.2s ease;

	&:hover {
		background-color: #f5f5f5;
	}
`

const LoadingItem = styled.li`
	padding: 10px;
	text-align: center;
	font-size: 12px;
	color: #999;
`

const Style = {
	Wrapper,
	Title,
	Container,
	SelectedValue,
	Arrow,
	DropdownList,
	OptionItem,
	LoadingItem,
}

export default Style
